module.exports = __webpack_public_path__ + "img/banner-87caa644.png";